const PARTNERS = {
	stockwave: 'stockwave',
};

export default PARTNERS;
